// extracted by mini-css-extract-plugin
module.exports = {"kitL":"kitL_kitL__6qjGZ"};